import { theme } from '@citygross/design-tokens';
import React from 'react';
import { BarContainer, Progress } from './ProgressBar.styled.js';

function ProgressBar(_a) {
  var _b, _c;

  var maxValue = _a.maxValue,
      currentValue = _a.currentValue,
      _d = _a.background,
      background = _d === void 0 ? (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.white : _d,
      _e = _a.color,
      color = _e === void 0 ? (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.alertBlue : _e,
      small = _a.small;
  var progress = currentValue / maxValue * 100;
  return React.createElement(BarContainer, {
    color: background,
    small: small
  }, React.createElement(Progress, {
    width: progress,
    color: color
  }));
}

export { ProgressBar };